<template>
    <div class="header">
        <div class="header--logo-console">
            <div class="header-left" @click="goHome">
                <img :src="Tenant.getInstance().theme.consoleLogo" alt="" class="logo" />
                <div class="title">
                    {{ theme.systemName }}
                </div>
            </div>
            <div v-if="isShow" class="header-console" @click="toConsole">控制台</div>
            <div v-if="showBackHomeBtn" class="back-home-btn" @click="goHome">返回首页</div>
        </div>
        <div class="d-flex user-head">
            <el-badge :value="allUnreadMsgNum || 0" :show-zero="false">
                <div @click="toUserMessage">
                    <i class="iconfont icon-xiaoxitixing" />
                </div>
            </el-badge>
            <user />
        </div>
    </div>
</template>

<script lang="ts" setup>
import User from "./components/user.vue";
import { theme } from "@/function/theme";
import Tenant from "@/function/tenant";
import { useRoute } from "vue-router";
import { computed } from "vue";
import { useUserStore } from "@/stores/user";
import { useRuntimeConfig } from "@/stores/runtimeConfig";
import { userMessageService } from "@/api/userMessage";
import { notificationService } from "@/api/notificationService";
import { openConsoleAdminPage } from "@/utils/common";

const route = useRoute();
const userStore = useUserStore();
const token = computed(() => userStore.token);
const isShow = computed(() => {
    // 账户 消息提醒 显示 控制台
    return route.path.includes("/me/") || route.path.includes("/userMessage");
});

const showBackHomeBtn = computed(() => {
    return /\/(orderCenter|logistics|followCenter)/.test(route.path);
});

const allUnreadMsgNum = ref(0);
const getUnReadMsgNum = async () => {
    if (token.value) {
        const res = await userMessageService.getMsgNum();
        const { unread }: number = await notificationService.getMsgNum();
        allUnreadMsgNum.value = res.transaction + res.other + res.transform + unread || 0;
        userStore.setAllUnreadMsgNum(allUnreadMsgNum.value);
    }
};
getUnReadMsgNum();

const goHome = () => {
    openConsoleAdminPage("/");
};
const toConsole = () => {
    window.open(`${window.location.origin}${useRuntimeConfig().public.publicPath}/logistics/findLocation`);
};

const toUserMessage = () => {
    if (route.path.includes("/userMessage")) {
        // 刷新
        location.reload();
    } else {
        window.open(`${window.location.origin}${useRuntimeConfig().public.publicPath}/userMessage`);
    }
};

// 轮询获取
const timer = ref<null | number>(null);
const clearTimer = () => {
    if (timer.value) window.clearInterval(timer.value);
};
const getUserMessageT = () => {
    timer.value = window.setInterval(async () => {
        await getUnReadMsgNum();
    }, 1000 * 10);
};
onMounted(() => {
    clearTimer();
    getUserMessageT();
});
onUnmounted(() => {
    clearTimer();
});
</script>

<style scoped lang="scss">
.header {
    box-sizing: border-box;
    width: 100vw;
    height: 60px;
    background: #ffffff;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 10px 16px;
    //box-shadow: rgba(0, 0, 0, 0.16) 0 5px 15px 0, rgba(0, 0, 0, 0.06) 0 0 0 1px;
    .header--logo-console {
        display: flex;
        align-items: center;
        gap: 20px;
        .header-console {
            padding: 8px 10px;
            border: 1px solid #d9d9d9;
            border-radius: 4px;
            cursor: pointer;
            font-size: 12px;
            color: #000000e0;
        }
    }

    .header-left {
        display: flex;
        align-items: center;
        cursor: pointer;
        .logo {
            height: 44px;
        }
        .title {
            color: #333333;
            font-size: 18px;
            font-weight: 600;
            line-height: 24px;
            margin-left: 8px;
        }
    }

    .back-home-btn {
        display: flex;
        align-items: center;
        justify-content: center;
        height: 30px;
        padding: 0 18px;
        border: 1px solid #d9d9d9;
        border-radius: 6px;
        color: #000000e0;
        font-size: 14px;
        line-height: 14px;
        cursor: pointer;
        transition: all 0.2s ease-in-out;

        &:hover {
            border-color: #165dff;
            color: #165dff;
        }
    }
}
.user-head {
    gap: 20px;
    .iconfont {
        font-size: 20px;
        cursor: pointer;
    }
}
:deep(.el-badge) {
    display: flex;
    align-items: center;
    .is-fixed {
        top: 6px;
    }
    .el-badge__content {
        height: 12px;
        font-size: 8px;
        line-height: 8px;
        background-color: #f32f31;
        padding: 0 4px;
    }
}
</style>
